export default function headerUI() {
	const $body = $('body');
	const $btn = $('.btn-menu');

	$('.modal-menu').on('show.bs.modal', function() {
		$body.addClass('menu-open');
		$btn.addClass('active');
	}).on('hide.bs.modal', function() {
		$body.removeClass('menu-open');
		$btn.removeClass('active');
	});
}
